var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"wrap",staticClass:"container",staticStyle:{"overflow":"auto","height":"100vh"}},[_c('div',{staticStyle:{"padding-top":"16em","padding-bottom":"23em"}},_vm._l((_vm.saleList),function(item){return _c('SiteItem',{attrs:{"item":item,"isAdmin":true,"show-btn":true},on:{"remove":_vm.onRemove}})}),1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-231a346a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents/main/admin/AdminWriteSale.vue
// module id = null
// module chunks = 